export const RESET_ORDER_STATE = 'order/resetOrderState';

export const resetOrderState = (payload) => ({ payload, type: RESET_ORDER_STATE });
